import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetCardBodyTitleSingleOffer from "./BetCardBodyTitleSingleOffer";

export default observer(function BetCardBodyTitle() {
	const bet = useContext(MyBetsBetContext);

	if (bet.betSlipOffers.length === 1 && bet.betSlipType.name !== "system") {
		return <BetCardBodyTitleSingleOffer />;
	}

	return (
		<>
			<span className="bet__title__inner bet--mini__title__inner u-type--wgt--regular">
				{bet.formattedBetSystemString}
			</span>
		</>
	);
});
